// extracted by mini-css-extract-plugin
export default {"container":"adminFooter_container__YeM7Q"};